import { getServedPathname } from './servedPage';

/**
 * Returns the "subdomain" (last two parts of hostname) for a given hostname.
 * Server-safe: pass any hostname string (e.g. from request.nextUrl.hostname).
 * Use this in Edge/middleware; use getSubdomain() when you have window.
 */
export const getSubdomainFromHostname = (hostname: string): string => {
	return hostname.split('.').slice(-2).join('.');
};

export const getDomain = () => {
	const url = new URL(window.location.href);
	return url.hostname;
};

export const getSubdomain = () => {
	const url = new URL(window.location.href);
	return getSubdomainFromHostname(url.hostname);
};

const servedOrBrowserPathname = (): string => getServedPathname() ?? window.location.pathname;

/** The served page's URL without its query string. `?test_url=` overrides it. */
export const getServedPageUrl = (): string => {
	const protocol = window.location.protocol;
	const hostName = window.location.hostname;
	const path = servedOrBrowserPathname();

	const params = new URLSearchParams(window.location.search);
	const testURL = params.get('test_url');

	if (testURL && process.env.VERCEL_ENV !== 'production') {
		// eslint-disable-next-line no-console
		console.log('Setting test URL', testURL);
		return testURL;
	}

	let url = `${protocol}//${hostName}${path}`;
	if (url === 'http://localhost/') url = 'localhost';

	return url;
};

/** The served page's URL with the address bar's query string. */
export const getServedPageUrlWithQuery = (): string => {
	const url = new URL(window.location.href);
	url.pathname = servedOrBrowserPathname();
	return url.href;
};
